"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGEX_URL = void 0;

/* 
 * One possible regular expression for validating strings as URLs
 * !Note that this regular expression will almost certainly yield 
 * false positives and false negatives
 */
var REGEX_URL = new RegExp('^((rtsp|https?):\\/\\/)?' + // protocol
'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
'(\\#[-a-z\\d_]*)?$', 'i');
exports.REGEX_URL = REGEX_URL;